// src/components/VolunteerOpportunity.js
import React from "react";
import styled from "styled-components";
import CTASection from "./CTASection"; // Ensure correct import path

const VolunteerOpportunity = ({
  title,
  image,
  details,
  requirements,
  workTypes,
  schedule,
  ctaTitle,
  ctaDescription,
  ctaButtonText,
  ctaButtonLink,
}) => {
  return (
    <Container>
      <h1>{title}</h1>
      <Image src={image} alt={title} />
      <Section>
        <h2>Details</h2>
        <p>{details}</p>
      </Section>
      <Section>
        <h2>Requirements</h2>
        <WorkList>
          {requirements.map((requirement, index) => (
            <li key={index}>{requirement}</li>
          ))}
        </WorkList>
      </Section>
      <Section>
        <h2>Types of Work</h2>
        <WorkList>
          {workTypes.map((workType, index) => (
            <li key={index}>{workType}</li>
          ))}
        </WorkList>
      </Section>
      <Section>
        <h2>Schedule</h2>
        <WorkList>
          {schedule.map((scheduleItem, index) => (
            <li key={index}>{scheduleItem}</li>
          ))}
        </WorkList>
      </Section>
      <CTASection
        title={ctaTitle}
        description={ctaDescription}
        buttonText={ctaButtonText}
        buttonLink={ctaButtonLink}
      />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
`;

const Image = styled.img`
  width: 100%;
  height: auto;
  margin-bottom: 20px;
  border-radius: 8px;
`;

const Section = styled.div`
  margin-top: 40px;
  text-align: left;

  h2 {
    color: var(--hhb-primary);
  }

  p {
    line-height: 1.6;
  }
`;

const WorkList = styled.ul`
  list-style-type: disc;
  padding-left: 20px;

  li {
    margin-bottom: 10px;
  }
`;

export default VolunteerOpportunity;
